import { isEmpty } from 'lodash';
import React from 'react';
import { useCachedDishFirstFilters } from '../../../hooks';
import { useAllCuisinesShowing } from '../../../store';
import { BaseFilterModal } from '../BaseFilterModal';
import { CuisineButton } from './CuisineButton';
import { useCuisineFilters } from './hooks';
import { CuisineContent } from './styles';

interface CuisineFilterModalProps {
  isShowing: boolean;
  onHide: () => void;
}

export const CuisineFilterModal: React.FC<CuisineFilterModalProps> = ({ isShowing, onHide }) => {
  const { showAllCuisines } = useAllCuisinesShowing();
  const { filters, availableCuisineCategories, allCuisineCategories } = useCachedDishFirstFilters({
    onChangeFilters: showAllCuisines,
  });

  const {
    handleFilterChange,
    moreCuisinesButtonProps,
    moreCuisineCategories,
    allCuisinesButtonProps,
    formattedCuisines,
  } = useCuisineFilters({
    availableCuisineCategories,
    allCuisineCategories,
    filters,
  });

  return (
    <BaseFilterModal filters={filters} isShowing={isShowing} onHide={onHide}>
      <CuisineContent>
        <CuisineButton {...allCuisinesButtonProps} />
        {formattedCuisines.map(({ cuisineFilter, isSelected, title }) => (
          <CuisineButton
            title={title}
            cuisineFilter={cuisineFilter}
            isSelected={isSelected}
            key={cuisineFilter}
            onChange={(cuisineFilter) => handleFilterChange(cuisineFilter, false)}
          />
        ))}
        {!isEmpty(moreCuisineCategories) && <CuisineButton {...moreCuisinesButtonProps} />}
      </CuisineContent>
    </BaseFilterModal>
  );
};
